import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import ConnectAPI from "../../../services/api";

const connectApi = new ConnectAPI();
function SpecialConditionDetailTypes_1  ({ specialCondition }) {
    const { t } = useTranslation();
    const [tableData, setTableData] = useState([]);
    const [tableConfig,setTableConfig]=useState([]);
    var fetchData;
    var config;
    const getConfigdata=(status, data) => {
        setTableConfig(data[0]);
    };
    useEffect(() => {
        config=()=>{
            connectApi.getWithParams("api/Channels/specialConditionConfig",specialCondition.idSpecialCondition , getConfigdata)
            .catch((error) => {
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            })
        }
        fetchData = () => {
            connectApi.getWithParams("api/Channels/specialConditionMaximumCostPerImpression", specialCondition.idSpecialCondition, getSCdataCallback)
                .catch((error) => {
                    Swal.fire(
                        "Error " + error?.response?.status,
                        error?.response?.data,
                        "error"
                    );
                });
        }
        config();
        fetchData();
        
    }, [specialCondition.idSpecialCondition]);
    
    let optDecimal = {
        style: 'decimal',
        maximumFractionDigits: 5
    };
    let getSCdataCallback;
    getSCdataCallback = (status, data) => {
        if(specialCondition.idSpecialConditionType==13)
            data.forEach(obj => {
                obj.minPrint = `${(Math.floor(obj.minPrint))} %`;
                obj.maxPrint = `${(Math.floor(obj.maxPrint))} %`;
            });
        setTableData(data);
    }
        return (<>
            {(specialCondition.idSpecialConditionType==26)?(
                <>LSMark Minimum:  {specialCondition.minimumImp}
                {(specialCondition.percentage>0)?(
                    <>
                    <br />Discount: {specialCondition.percentage*100}%
                    </>
                ):(null)}
                </>
            ):(<></>)}

            {(specialCondition.idSpecialConditionType===26 && specialCondition.percentage>0)?(null):(
                <>
                    <table className="table table-striped table-hover table-bordered table-sm " >
                        <thead>
                            <tr>
                                <th scope="col" className="text-center">
                                    {specialCondition.idSpecialConditionType==13 ?("Min LS Mark"):("Min Print")}
                                </th>
                                <th scope="col" className="text-center">
                                    {specialCondition.idSpecialConditionType==13 ?("Max LS Mark"):("Max Print")}
                                </th>
                                {(tableConfig )?(
                                    (tableConfig.blackVisible==true )?(
                                        <th scope='col' className='text-center'>Black CPP</th>
                                        ):("")
                                ):(
                                    ""
                                )}
                                {(tableConfig )?(
                                    (tableConfig.otherVisible==true )?(
                                        <th scope='col' className='text-center'>Other CPP</th>
                                        ):("")
                                ):(
                                    ""
                                )}
                                {(tableConfig )?(
                                    (tableConfig.oneShotVisible==true )?(
                                        <th scope='col' className='text-center'>One Shot CPP</th>
                                        ):("")
                                ):(
                                    ""
                                )}
                                {(tableConfig )?(
                                    (tableConfig.whiteVisible==true )?(
                                        <th scope='col' className='text-center'>White CPP</th>
                                        ):("")
                                ):(
                                    ""
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row, index)=>{
                                return (
                                    <tr>
                                        <td scope='col'>{row.minPrint.toLocaleString()}</td>
                                        <td scope='col'>{row.maxPrint.toLocaleString()}</td>
                                        {(tableConfig.blackVisible==true)?(
                                            <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.blackCpp)}</td>
                                        ):("")}
                                        {(tableConfig.otherVisible==true)?(
                                            <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.otherCpp)}</td>
                                        ):("")}
                                        {(tableConfig.oneShotVisible==true)?(
                                            <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.oneShotCpp)}</td>
                                        ):("")}
                                        {(tableConfig.whiteVisible==true)?(
                                            <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.whiteCpp)}</td>
                                        ):("")}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    
                    *<label style={{fontSize: '12px'}} >{t("note_table")}</label>
                </>
            )}
            
            <br/>
        </>);
    
    
}

export default SpecialConditionDetailTypes_1;